import * as types from "./actionTypes";
import * as userApi from "../../api/userApi";
// import { beginApiCall, apiCallError } from "./user";

export function loadingUser() {
  return { type: types.LOADING_USER };
}
export function createUserSuccess(user) {
  return { type: types.CREATE_USER_SUCCESS, user };
}
export function getUserSuccess(user) {
  return { type: types.GET_USER_SUCCESS, user };
}

export function apiUserError(error) {
  return { type: types.API_USER_ERROR, error };
}

export function getUser() {
  return function (dispatch) {
    dispatch(loadingUser());
    return userApi
      .getUser()
      .then((user) => {
        dispatch(getUserSuccess(user));
      })
      .catch((error) => {
        dispatch(apiUserError(error.response));
        throw error;
      });
  };
}

export function createUser(data) {
  return function (dispatch) {
    dispatch(loadingUser());
    return userApi
      .createUser(data)
      .then((user) => {
        dispatch(createUserSuccess(user));
      })
      .catch((error) => {
        dispatch(apiUserError(error.response));
        throw error;
      });
  };
}
